import { render } from "./ReserveAVehicle.vue?vue&type=template&id=2958d95a&lang=true"
import script from "./ReserveAVehicle.vue?vue&type=script&lang=js"
export * from "./ReserveAVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__